import React from 'react';

export const BlockStreamItem = React.lazy(async () => {
    const { BlockStreamItem } = await import(
        /* webpackChunkName: 'block-stream-item' */
        './BlockStreamItem'
    );
    return { default: BlockStreamItem };
});
